export interface NoraCredentialsApi {
  getCredentials(): Promise<{ token?: string }>;
}

export class NoraApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'NoraApiError';
  }
}

export async function noraRequest<T>(
  credentialsApi: NoraCredentialsApi,
  baseUrl: string,
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const { token } = await credentialsApi.getCredentials();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (init.body && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${baseUrl}${path}`, { ...init, headers });
  if (!response.ok) {
    throw new NoraApiError(
      `Nora request failed (${response.status})`,
      response.status,
    );
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export async function noraDownload(
  credentialsApi: NoraCredentialsApi,
  baseUrl: string,
  path: string,
): Promise<Blob> {
  const { token } = await credentialsApi.getCredentials();
  const response = await fetch(`${baseUrl}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!response.ok) {
    throw new NoraApiError(
      `Nora download failed (${response.status})`,
      response.status,
    );
  }
  return response.blob();
}
